import React, { Component } from 'react';
import { Collapse } from 'reactstrap';
import { Configurations } from '../../../Utils/Configurations';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import makeAnimated from 'react-select/lib/animated';
import Select from 'react-select';
import InputTag from '../../Input-Tag/Input-Tag';
import VinculoPedido from './Order-Link';
import VinculoMembro from './User-Link';

const colourStyles = {
    option: (styles, { data, isDisabled, isFocused, isSelected }) => {
        return {
            ...styles,
            fontWeight: data.pai ? 'bold' : 'normal',
            textTransform: data.pai ? 'uppercase' : 'capitalize',
            textIndent: data.pai ? 0 : 50,
            // paddingLeft: data.pai ? styles.paddingLeft : 30,
            // paddingLeft: data.pai ? 0 : 30,
            display: 'list-item',
            listStyleType: 'square',
        };
    },
};

class CardOcorrencia extends Component {
    constructor(props) {
        super(props);

        this.handleOnChange = this.handleOnChange.bind(this);
        this.handleSelectChange = this.handleSelectChange.bind(this);
        this.adicionarCategoria = this.adicionarCategoria.bind(this);
        this.atualizaTags = this.atualizaTags.bind(this);
        this.salvarOcorrencia = this.salvarOcorrencia.bind(this);
        this.excluirOcorrencia = this.excluirOcorrencia.bind(this);
        this.toggleCollapse = this.toggleCollapse.bind(this);
        this.adicionarVinculo = this.adicionarVinculo.bind(this);
        this.removerVinculo = this.removerVinculo.bind(this);
        this.atualizarVinculo = this.atualizarVinculo.bind(this);
        this.toggleModalOcorrencia = this.toggleModalOcorrencia.bind(this);
        this.toggleModalVinculo = this.toggleModalVinculo.bind(this);

        this.state = {
            isOpen: true,
            descricaoOcorrencia: this.props.ocorrencia.descricaoOcorrencia,
            tagCategorias: this.props.listaCategorias,
            novaCategoria: null,
            novoVinculo: null,
            habilitaNovoVinculo: true,
            listaVinculos: [],
            opcoesVinculos: [
                { label: "Membro", value: 1 },
                { label: "Pedido", value: 2 }
            ],
            modalExcluirOcorrencia: false,
            modalExcluirVinculo: false,
            indexVinculoExcluir: null,
        }

        this.pendenciaOcorrencia = {
            pendente: false,
            btnClick: false
        }

        this.configurations = new Configurations();

        this.opcoesVinculos = [
            { label: "Membro", value: 1 },
            { label: "Pedido", value: 2 }
        ]
    }

    handleOnChange(e) {
        e.preventDefault();
        this.setState({ [e.target.name]: e.target.value })
        this.props.registraPendencia((this.props.index) - 1);
        this.pendenciaOcorrencia.pendente = true;
        this.pendenciaOcorrencia.btnClick = false;
    }

    async componentDidMount() {
        const _idPedido = this.props.ocorrencia.idPedido;
        const _idUsuario = this.props.ocorrencia.idUsuario;
        const _codMembro = this.props.ocorrencia.codMembro;
        if (_idPedido) {
            await this.setState({ novoVinculo: { label: "pedido" } }, () => {
                this.adicionarVinculo(_idPedido, null, true);
            })
        }
        if (_idUsuario) {
            this.setState({ novoVinculo: { label: "membro" } }, () => {
                this.adicionarVinculo(_idUsuario, _codMembro, true);
            })
        }
    }

    handleSelectChange(newValue, actionMeta) {
        // if (!this.state.temAlteracao) this.setState({ temAlteracao: true });
        // let _secao;
        // switch (actionMeta.action) {
        //     case "clear": _secao = null; break;
        //     case "select-option": _secao = { value: newValue.value, label: newValue.label }; break;
        //     case "create-option": _secao = { label: newValue.label }; break;
        //     default: _secao = null; break;
        // }
        this.setState({ [actionMeta.name]: newValue })
    };

    adicionarCategoria() {
        let _arrayAtualCategorias = this.state.tagCategorias;
        let _novosValores = this.state.novaCategoria;

        _novosValores = _novosValores.filter(item => {
            return !(_arrayAtualCategorias.some(cat => cat.value === item.value));
        })

        const _novoArrayCategorias = _arrayAtualCategorias.concat(_novosValores);

        this.setState({
            tagCategorias: _novoArrayCategorias,
        }, () => {
            this.handleSelectChange(null, { action: "clear", name: "novaCategoria" })
            this.props.registraPendencia((this.props.index) - 1);
            this.pendenciaOcorrencia.pendente = true;
        });
    }

    adicionarVinculo(value = null, info = null, flagDidMount) {
        const _tipo = this.state.novoVinculo.label.toLowerCase()

        let _novasOpcoesVinculos = this.state.opcoesVinculos;
        _novasOpcoesVinculos = _novasOpcoesVinculos.map(item => {
            if (item.label.toLowerCase() === _tipo) return { ...item, isDisabled: true }
            else return item;
        });

        let _novaLista = this.state.listaVinculos;
        _novaLista.push({ tipo: _tipo, value: value, info: info, ativo: true });

        this.setState({
            listaVinculos: _novaLista,
            opcoesVinculos: _novasOpcoesVinculos
        }, () => {
            if (!flagDidMount) {
                this.props.registraPendencia((this.props.index) - 1);
                this.pendenciaOcorrencia.pendente = true;
                this.pendenciaOcorrencia.btnClick = false;
            }
            this.handleSelectChange(null, { action: "clear", name: "novoVinculo" })
        });
    }

    atualizarVinculo(index, value, info = null) {
        let _novaLista = this.state.listaVinculos;
        _novaLista[index].value = value;
        if (info) _novaLista[index].info = info;
        this.setState({ listaVinculos: _novaLista }, () => {
            this.props.registraPendencia((this.props.index) - 1);
            this.pendenciaOcorrencia.pendente = true;
            this.pendenciaOcorrencia.btnClick = false;
        })
    }

    removerVinculo(index) {
        let _novaLista = this.state.listaVinculos;
        _novaLista[index].ativo = false;

        const _tipo = _novaLista[index].tipo;

        let _novasOpcoesVinculos = this.state.opcoesVinculos;
        _novasOpcoesVinculos = _novasOpcoesVinculos.map(item => {
            if (item.label.toLowerCase() === _tipo) return { ...item, isDisabled: false }
            else return item;
        });

        this.setState({ listaVinculos: _novaLista, opcoesVinculos: _novasOpcoesVinculos, modalExcluirVinculo: false }, () => {
            this.props.registraPendencia((this.props.index) - 1);
            this.pendenciaOcorrencia.pendente = true;
            this.pendenciaOcorrencia.btnClick = false;
        });
    }

    atualizaTags(tags) {
        this.setState({ tagCategorias: tags }, () => {
            this.props.registraPendencia((this.props.index) - 1);
            this.pendenciaOcorrencia.pendente = true;
            this.pendenciaOcorrencia.btnClick = false;
        })
    }

    salvarOcorrencia() {
        const _temMembro = this.state.listaVinculos.filter(item => item.tipo === "membro" && item.ativo).length > 0,
            _temPedido = this.state.listaVinculos.filter(item => item.tipo === "pedido" && item.ativo).length > 0;
        const _dadosOcorrencia = {
            listaCategoria: this.state.tagCategorias.map(item => item.value),
            descricaoOcorrencia: this.state.descricaoOcorrencia ? this.state.descricaoOcorrencia : '',
            idUsuario: _temMembro ? this.state.listaVinculos.filter(item => item.tipo === "membro" && item.ativo)[0].value : undefined,
            idPedido: _temPedido ? this.state.listaVinculos.filter(item => item.tipo === "pedido" && item.ativo)[0].value : undefined,
        },
            _idOcorrencia = this.props.ocorrencia.idOcorrencia;
        this.pendenciaOcorrencia.btnClick = true;
        this.props.salvarOcorrencia(_idOcorrencia, _dadosOcorrencia);
    }

    excluirOcorrencia() {
        const _idOcorrencia = this.props.ocorrencia.idOcorrencia;
        this.pendenciaOcorrencia.btnClick = true;
        this.props.excluirOcorrencia(_idOcorrencia)
        this.toggleModalOcorrencia();
    }

    toggleCollapse() {
        this.setState({ isOpen: !this.state.isOpen })
    }

    toggleModalOcorrencia() {
        this.setState({ modalExcluirOcorrencia: !this.state.modalExcluirOcorrencia })
    }

    toggleModalVinculo(index) {
        this.setState({ modalExcluirVinculo: !this.state.modalExcluirVinculo }, () => {
            this.setState({ indexVinculoExcluir: this.state.modalExcluirVinculo ? index : null })
        })
    }

    render() {
        const { idOcorrencia } = this.props.ocorrencia;
        return (
            <div className="card rounded card-ocorrencia pb-2">
                <div onClick={this.toggleCollapse} className={`card-header bg-info text-white cursor-pointer ${this.state.isOpen ? '' : 'rounded'}`}>
                    <div className="row no-gutters align-items-center">
                        <div className="col-10">
                            <h5 className="m-0 font-weight-bold">Ocorrência {this.props.index} (id: {idOcorrencia})</h5>
                        </div>
                        <div className="col-2 text-right">
                            <i onClick={this.toggleCollapse} className={`fas fa-chevron-${this.state.isOpen ? 'up' : 'down'} text-white fa-2x`}></i>
                        </div>
                    </div>
                </div>
                <Collapse isOpen={this.state.isOpen}>
                    <div className="card-body">
                        <div className="row no-gutters">
                            <div className="col-12">
                                <label><strong>Descrição:</strong></label>
                            </div>
                            <div className="col-12 pb-2">
                                <textarea name="descricaoOcorrencia" rows="2" className="w-100 form-control" onChange={this.handleOnChange} value={this.state.descricaoOcorrencia ? this.state.descricaoOcorrencia : ''} disabled={this.props.pedidoFinalizado} />
                            </div>
                            <div className="col-8 py-2">
                                <div className="form-inline">
                                    <Select
                                        id="ddlCategorias"
                                        placeholder="Adicionar categorias..."
                                        closeMenuOnSelect={true}
                                        components={makeAnimated()}
                                        // defaultValue={this.state.novaCategoria}
                                        options={this.props.categorias}
                                        onChange={this.handleSelectChange}
                                        name="novaCategoria"
                                        styles={colourStyles}
                                        className="w-50"
                                        isClearable
                                        isMulti
                                        value={this.state.novaCategoria}
                                        isDisabled={this.props.pedidoFinalizado}
                                    />
                                    {this.state.novaCategoria && (
                                        <button onClick={this.adicionarCategoria} className="btn btn-sm btn-outline-primary ml-2">adicionar</button>
                                    )}
                                </div>
                                <div className="tags-categorias-ocorrencias">
                                    <InputTag atualizaTags={this.atualizaTags} tags={this.state.tagCategorias} selectInput={true} pedidoFinalizado={this.props.pedidoFinalizado} />
                                </div>
                            </div>
                            <div className="col-6 py-2">
                                <div className="form-inline">
                                    <Select
                                        id="ddlVinculos"
                                        placeholder="Adicionar vínculo..."
                                        closeMenuOnSelect={true}
                                        components={makeAnimated()}
                                        // defaultValue={this.state.novaCategoria}
                                        options={this.state.opcoesVinculos}
                                        onChange={this.handleSelectChange}
                                        name="novoVinculo"
                                        className="w-50"
                                        isClearable
                                        value={this.state.novoVinculo}
                                        isDisabled={this.props.pedidoFinalizado}
                                    />
                                    {this.state.novoVinculo && (
                                        <button onClick={() => this.adicionarVinculo(null, null)} className="btn btn-sm btn-outline-primary ml-2">adicionar</button>
                                    )}
                                </div>
                            </div>
                            <div className="col-12">
                                {this.state.listaVinculos && this.state.listaVinculos.map((item, index) => {
                                    if (item.ativo) {
                                        if (item.tipo === "membro") {
                                            return (
                                                <VinculoMembro
                                                    key={`vinculo-${index}`}
                                                    index={index}
                                                    atualizar={this.atualizarVinculo}
                                                    vinculo={item}
                                                    // remover={this.removerVinculo}
                                                    remover={this.toggleModalVinculo}
                                                    pedidoFinalizado={this.props.pedidoFinalizado}
                                                />
                                            )
                                        } else if (item.tipo === "pedido") {
                                            return (
                                                <VinculoPedido
                                                    key={`vinculo-${index}`}
                                                    index={index}
                                                    atualizar={this.atualizarVinculo}
                                                    vinculo={item}
                                                    // remover={this.removerVinculo}
                                                    remover={this.toggleModalVinculo}
                                                    pedidoFinalizado={this.props.pedidoFinalizado}
                                                />
                                            )
                                        } else return false;
                                    } else return false;
                                })}
                            </div>
                            <div className="col-12 text-right pt-3">
                                <div className="row no-gutters">
                                    {this.props.loadingOcorrencia ? (
                                        <div className="col-12 text-right px-5">
                                            <div className="spinner-border text-primary" role="status" />
                                        </div>

                                    ) : (
                                            <div className={`col-12`}>
                                                {
                                                    this.props.ocorrencia.btnClick && !this.props.ocorrencia.pendente && (
                                                        <span className="my-0 mr-4 text-success alerta-alteracoes">Alterações salvas com sucesso!</span>
                                                    )}
                                                {this.props.ocorrencia.pendente && (
                                                    <span className="my-0 mr-4 text-danger alerta-alteracoes">As alterações {this.props.pedidoFinalizado ? '' : 'ainda'} não foram salvas.</span>
                                                )}
                                                <button onClick={this.toggleModalOcorrencia} disabled={this.props.pedidoFinalizado} className={`btn btn-sm btn-outline-danger mr-3 btn-ocorrencia ${this.props.pedidoFinalizado ? 'd-none' : ''}`}>
                                                    excluir ocorrência
                                                    </button>
                                                <button onClick={this.salvarOcorrencia} disabled={this.props.pedidoFinalizado} className={`btn btn-sm btn-outline-success btn-ocorrencia ${this.props.pedidoFinalizado ? 'd-none' : ''}`}>salvar ocorrência</button>
                                            </div>
                                        )}
                                </div>
                            </div>
                        </div>
                    </div>
                </Collapse>
                <Modal isOpen={this.state.modalExcluirOcorrencia} toggle={this.toggleModalOcorrencia}>
                    <ModalHeader toggle={this.toggleModalOcorrencia}>Exclusão de Ocorrência</ModalHeader>
                    <ModalBody>
                        <p className="m-0">Deseja confirmar a exclusão de ocorrência? Essa ação não poderá ser revertida.</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.excluirOcorrencia} color="danger">excluir</Button>
                        {` `}
                        <Button onClick={this.toggleModalOcorrencia} color="secondary">voltar</Button>
                    </ModalFooter>
                </Modal>

                <Modal isOpen={this.state.modalExcluirVinculo} toggle={this.toggleModalVinculo}>
                    <ModalHeader toggle={this.toggleModalVinculo}>Exclusão de Vínculo</ModalHeader>
                    <ModalBody>
                        <p className="m-0">Deseja confirmar a exclusão de vínculo? Essa ação não poderá ser revertida.</p>
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={() => this.removerVinculo(this.state.indexVinculoExcluir)} color="danger">excluir</Button>
                        {` `}
                        <Button onClick={this.toggleModalVinculo} color="secondary">voltar</Button>
                    </ModalFooter>
                </Modal>
            </div >
        )
    }
}

export default CardOcorrencia;